import type {Badge} from '@/types/loyalty';

import BadgeImage from '../../components/BadgeCard/BadgeImage';

type BadgeStackProps = {
    /** Up to 3 badges to display stacked. Additional badges are ignored. */
    badges: Badge[];
};

const CONTAINER_WIDTH = 68;
const IMAGE_SIZE = 48;

/**
 * Stacked badge icons in a fixed-width container.
 * 1 badge: centered; 2 badges: left + right; 3 badges: evenly spaced.
 * Each badge overlaps the next; first badge is on top.
 */
const BadgeStack = ({badges}: BadgeStackProps) => {
    const items = badges.slice(0, 3);
    const n = items.length;
    const step = n > 1 ? (CONTAINER_WIDTH - IMAGE_SIZE) / (n - 1) : 0;

    return (
        <div className='relative h-12 w-17'>
            {items.map((badge, i) => {
                const {id, imageUrl, title} = badge;
                const left = n === 1 ? (CONTAINER_WIDTH - IMAGE_SIZE) / 2 : step * i;
                return (
                    <BadgeImage
                        key={id}
                        imageUrl={imageUrl}
                        alt={title}
                        size={IMAGE_SIZE}
                        className='absolute'
                        style={{left, zIndex: n - i}}
                    />
                );
            })}
        </div>
    );
};

export default BadgeStack;
